import React from 'react';

export type EmobilityFilter = {
  mbv?: string;
  salesgroup?: string;
  actioncode?: string;
  mileage?: number;
  fuelconsumption?: number;
  charging_home?: number;
  charging_public?: number;
  charging_ac?: number;
  charging_dc?: number;
  charging_ionity?: number;
  ownershipperiod?: number;
  batterylevel?: 80 | 100;
  chargingPrice?: number;
  fuelPrice?: number;
  drivingEnvironment?: string;
  drivingStyle?: string;
  occupancy?: string;
  season?: string;
  temperature?: number;
};

export type EmobilityFilterActions = {
  onEngineChange: (mbv: string, salesgroup: string, actioncode: string) => void;
  onMileageChange: (value: number) => void;
  onFuelconsumptionChange: (value: number) => void;
  onChargingPreferenceChange: (home: number, publ: number) => void;
  onChargingChange: (ac: number, dc: number, ionity: number) => void;
  onOwnershipperiodChange: (value: number) => void;
  onBatterylevelChange: (value: 80 | 100) => void;
  onChargingPriceChange: (value: number) => void;
  onFuelPriceChange: (value: number) => void;
  onDrivingEnvironmentChange: (value: string) => void;
  onDrivingStyleChange: (value: string) => void;
  onOccupancyChange: (value: string) => void;
  onSeasonChange: (value: string) => void;
  onTemperatureChange: (value: number) => void;
};

export type EmobilityFilterContextValue = {
  original?: EmobilityFilter;
  current?: EmobilityFilter;
  actions?: EmobilityFilterActions;
};

const getEmptyEmobilityFilter = (): EmobilityFilter => ({
  batterylevel: null,
  charging_ac: null,
  charging_dc: null,
  charging_home: null,
  charging_ionity: null,
  charging_public: null,
  fuelconsumption: null,
  mbv: null,
  mileage: null,
  ownershipperiod: null,
  salesgroup: null,
  actioncode: null,
  chargingPrice: null,
  fuelPrice: null,
  drivingEnvironment: null,
  drivingStyle: null,
  occupancy: null,
  season: null,
  temperature: null
});

export const EmobilityFilterContext =
  React.createContext<EmobilityFilterContextValue>({
    original: getEmptyEmobilityFilter(),
    current: getEmptyEmobilityFilter(),
    actions: null
  });
